import { render, staticRenderFns } from "./PopupManager.vue?vue&type=template&id=16d53ead&scoped=true"
import script from "./PopupManager.vue?vue&type=script&lang=js"
export * from "./PopupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d53ead",
  null
  
)

export default component.exports